import { Box, Typography } from '@mui/material';
import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';
import { useTranslation } from 'react-i18next';
import { useMaterialUIController } from 'context';
import { getCrmColors } from '../../crm-theme';
import { formatCrmDateTime } from '../../formatters/crm-datetime';
import { ELeadOutcome, LeadResponse } from '../../services/responses/lead.response';
import { closedCardSx, closedTitleSx } from './crm-closed-leads.styles';

interface Props {
    leads: LeadResponse[];
    onOpen: (lead: LeadResponse) => void;
}

/// Ganhos e perdidos da coluna; card próprio, pois o CrmLeadCard entra no dnd-kit e mudaria o drop.
export const CrmClosedLeads = ({ leads, onOpen }: Props) => {
    const { t } = useTranslation();
    const [controller] = useMaterialUIController();
    const cc = getCrmColors(controller.darkMode);

    if (leads.length === 0) return null;

    const money = (value?: number | null) =>
        value == null ? null : value.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });

    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.75, mt: 1 }}>
            <Typography sx={closedTitleSx(cc)}>
                {t('crmKanban.encerrados', { total: leads.length })}
            </Typography>

            {leads.map((lead) => {
                const won = lead.outcome === ELeadOutcome.Won;
                const color = won ? cc.eventSuccess : cc.eventDanger;
                const detail = won ? money(lead.closedValue ?? lead.value) : lead.lossReasonName;

                return (
                    <Box
                        key={lead.id}
                        role="button"
                        tabIndex={0}
                        onClick={() => onOpen(lead)}
                        onKeyDown={(e) => e.key === 'Enter' && onOpen(lead)}
                        sx={closedCardSx(cc, color)}
                    >
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75 }}>
                            {won
                                ? <CheckIcon sx={{ fontSize: '15px !important', color }} />
                                : <CloseIcon sx={{ fontSize: '15px !important', color }} />}
                            <Typography
                                noWrap
                                sx={{ flex: 1, minWidth: 0, fontSize: 13, fontWeight: 600, color: cc.textPrimary }}
                            >
                                {lead.contactName}
                            </Typography>
                        </Box>

                        <Typography noWrap sx={{ fontSize: 11.5, color: cc.textSecondary, mt: 0.25 }}>
                            {won ? t('crmKanban.ganhoEm') : t('crmKanban.perdidoEm')}{' '}
                            {lead.outcomeAt ? formatCrmDateTime(lead.outcomeAt) : '—'}
                            {detail ? ` · ${detail}` : ''}
                        </Typography>
                    </Box>
                );
            })}
        </Box>
    );
};
